// extracted by mini-css-extract-plugin
export default {"sharingOptionsVertical":"SharingOptions_sharingOptionsVertical__Apmo9","sharingOptionsHorizontal":"SharingOptions_sharingOptionsHorizontal__IKWr6"};